//
// DISCLAIMER
//
// Copyright 2024-2026 ArangoDB GmbH, Cologne, Germany
//

import React from "react";
import { Form, Modal } from "semantic-ui-react";
import { FormActionButtonCancel, FormActionButtonSave } from "../../ui/lib";
import { NotificationData, NotificationFields, emptyNotificationData } from "./NotificationFields";

export const CreateNotificationModal = ({
  onClose,
  onCreateNotification,
}: {
  onClose: () => void;
  onCreateNotification: (values: NotificationData) => Promise<void>;
}) => {
  const [notification, setNotification] = React.useState<NotificationData>(emptyNotificationData());
  const [processing, setProcessing] = React.useState(false);
  const onSubmit = async () => {
    setProcessing(true);
    await onCreateNotification(notification);
    setProcessing(false);
    onClose();
  };
  return (
    <Modal open={true} size="large">
      <Modal.Header>Create new notification</Modal.Header>
      <Modal.Content scrolling>
        <Form onSubmit={onSubmit}>
          <NotificationFields value={notification} onChange={setNotification} disabled={processing} />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <FormActionButtonCancel icon="cancel" onClick={onClose} />
        <FormActionButtonSave primary type="submit" onClick={onSubmit} disabled={processing} />
      </Modal.Actions>
    </Modal>
  );
};
